import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import themes from '../../js/stores/theme.js';
import language from '../../js/stores/language.js';
import user from '../../js/stores/user.js';
import device from '../../js/stores/device.js';
var RightPanelPage = function RightPanelPage(props, _ref) {
  var $f7 = _ref.$f7,
    $ = _ref.$,
    $on = _ref.$on,
    $onMounted = _ref.$onMounted,
    $update = _ref.$update,
    $f7router = _ref.$f7router,
    $emit = _ref.$emit;
  var theme = themes.getters.Name.value;
  var lang = language.getters.Name.value;
  var isLogged = user.getters.isLogged.value;
  var locale = language.getters.Item.value;
  var displayName = user.getters.displayName.value['contactName'] || '';
  var selectLanguage = null;
  var availableLanguages = [];
  var defaultLanguage = 'English';
  var isTokenSaved = device.getters.IsTokenSaved.value;
  var isDesktop = $f7.device.desktop ? true : false;
  var onPanelOpen = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isLogged = user.getters.isLogged.value;
            $update();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onPanelOpen() {
      return _ref2.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var key, obj;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          for (key in locale.dicts) {
            obj = {
              value: key,
              displayValue: locale.dicts[key].originalWriting,
              isSelected: lang == key ? 1 : 0
            };
            availableLanguages.push(obj);
            if (lang == key) {
              defaultLanguage = locale.dicts[key].originalWriting;
            }
          }
          $('#light-theme').prop('checked', theme != 'dark' ? true : false);
          _context2.next = 1;
          return themes.dispatch('checkTheme', '.panel-right');
        case 1:
          selectLanguage = $f7.smartSelect.create({
            el: '#smart-select-language',
            searchbar: false,
            closeOnSelect: 'true'
          });
          $update();
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var logout = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return user.dispatch('logOut');
          case 1:
            $f7.toast.show({
              text: locale.translate('home.panelRight.sessionLogOutMessage')
            });
            $f7.views.main.router.navigate('/', {
              reloadAll: true,
              ignoreCache: true
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function logout() {
      return _ref4.apply(this, arguments);
    };
  }();
  var setTheme = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var name;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if ($("#light-theme").prop('checked')) {
              $("#app, .panel-right").removeClass("dark");
            } else {
              $("#app, .panel-right").addClass("dark");
            }
            name = !$("#light-theme").prop('checked') ? 'dark' : '';
            _context4.next = 1;
            return themes.dispatch('setTheme', name);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function setTheme() {
      return _ref5.apply(this, arguments);
    };
  }();
  var setLang = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var lang;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            lang = selectLanguage.getValue();
            _context5.next = 1;
            return language.dispatch('setLanguage', lang);
          case 1:
            $emit('reloadLanguage');
            $update();
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function setLang() {
      return _ref6.apply(this, arguments);
    };
  }();

  // const askPermission = async () => {
  //   console.log('Requesting permission...');
  //   let result = await Notification.requestPermission();
  //   //Notification.permission {denied, granted, default}
  //   if (result === 'granted') {
  //     const response = await device.dispatch('sendTokenToServer', currentToken);
  //     if (response.status !== undefined && response.status !== 201) {
  //       console.log(response.data.messages.error);
  //       return;
  //     }
  //     console.log('Notification permission granted.');
  //   }
  //   else if (result === 'denied') {
  //     //await device.dispatch('unregisterDevice');
  //     console.log("Notification permission denied");
  //     $f7.toast.show( { text: 'If you don not allow notifications, you will be not be able to receive messages when you a get request for your car or when someone ask for yours', closeTimeout: 4000 } );
  //   }
  // };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<!-- Right panel with reveal effect-->
<div class="panel panel-right panel-reveal dark" @panel:open=${onPanelOpen}>
  <div class="view">
    <div class="page">
      <div class="navbar">
        <div class="navbar-inner">
          <div class="title">Menu</div>
        </div>
      </div>
      <!-- Content -->
      <div class="page-content">
        <div class="list">
          <ul>
            ${isLogged && $h`
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('home.panelRight.userLabel')}</div>
                  <div class="item-input-wrap">
                    <i class="icon f7-icons color-blue">person</i>
                    <span id="menu-username">${displayName}</span>
                  </div>
                </div>
              </div>
            </li>
            `}
            <li>
              <div class="item-content">
                <div class="item-inner">
                  <div class="item-title">${locale.translate('home.panelRight.lightThemeLabel')}</div>
                  <div class="item-after">
                    <label class="toggle toggle-init">
                      <input type="checkbox" id="light-theme" @click=${setTheme} checked="${theme != 'dark' && $h`checked`}" /><i class="toggle-icon"></i>
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a id="smart-select-language" href="#" class="item-link smart-select">
                <select name="language" @change="${setLang}">
                ${availableLanguages.map((list) => $h`
                  <option value="${list.value}" selected="${list.isSelected > 0 && $h`selected`}" >${list.displayValue}</option>
                `)}  
                </select>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title">${locale.translate('home.panelRight.selectLanguageLabel')}</div>
                    <div class="item-after">${defaultLanguage}</div>
                  </div>
                </div>
              </a>
            </li>
            ${isLogged && isDesktop && $h`
            <!-- <li>
              <div class="item-content">
                <div class="item-inner">
                  <div class="item-title">${locale.translate('home.panelRight.allowWebNotifications')}</div>
                  <div class="item-after">
                    <label class="toggle toggle-init">
                      <input type="checkbox" id="allow-notifications" checked="${isTokenSaved > 0 && $h`checked`}" /><i class="toggle-icon"></i>
                    </label>
                  </div>
                </div>
              </div>
            </li> -->
            `}
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('home.panelRight.sessionLabel')}</div>
                  <div class="item-input-wrap">
                    ${isLogged && $h`
                    <a class="link panel-close color-yellow" href="#" @click=${logout}>
                      ${locale.translate('home.panelRight.sessionLogOutLabel')} <span class="material-icons">logout</span>
                    </a>
                    `}
                    ${!isLogged && $h`
                    <a class="link panel-close color-green" href="/user-login/">
                      <span class="material-icons">login</span> ${locale.translate('home.panelRight.sessionLogInLabel')}
                    </a>
                    <br/>
                    <a class="link panel-close color-green" href="/user-new/">
                      <span class="material-symbols-outlined">app_registration</span> ${locale.translate('home.panelRight.userRegister')}
                    </a>
                    `}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
};
export default RightPanelPage;